<template>
    <div class="timepicker">
        <date-picker mode="time" @input="action" v-model="date" :timezone="timezone" :is24hr="format24h" />
    </div>
</template>

<script>
// packages
import { ref, computed } from '@vue/composition-api';

// hooks
import { reset } from '@/hooks/use-input-listeners';

// componentes
import { DatePicker, Locale } from 'v-calendar';

// utils
import { haveProperty } from '@/utils/';

// definições das datas.
const locale = new Locale();
const defaultFormat = 'HH:mm';

export default {
    inheritAttrs: false,
    components: {
        DatePicker
    },
    props: {
        targetClass: String,
        reset: Boolean,
        defaultValue: String,
        format24h: {
            type: Boolean,
            default: true
        },
        configs: {
            type: Object,
            default: () => ({})
        },
        settings: Object
    },
    setup ( props, { emit }) {
        const dateString = ref( props.defaultValue );
        const format = props.configs?.format || defaultFormat;
        const mask = { input: format };

        // listener para quando for necessário
        // proceder a um reset a input.
        reset({
            props,
            object: dateString,
            key: 'value'
        });

        /**
         * Formatação da data.
         *
         * @param {String/Date} date
         * @param {String} type - parse / formate
         * @since 1.0.0
         * @category Method
         * @autor Tiago Martinho
         *
        */
        const formatDate = ( date, type ) => locale[type]( date, format );

        // formatação da data.
        const date = computed({
            get: () => ( dateString.value ? formatDate( dateString.value, 'parse' ) : null ),
            set: newDate => {
                dateString.value = newDate ? formatDate( newDate, 'format' ) : '';
            }
        });

        const timezone = '';
        // emite o valor para o compomente pai.
        const action = () => {
            emit( 'input', `${dateString.value}:00` );
        };

        return {
            date,
            mask,
            action,
            haveProperty,
            timezone
        };
    }
};
</script>
<style lang="scss">
    .timepicker .vc-container{
        border: none;
        .vc-time-picker {
            svg, .vc-date {
                display: none;
            }
        }
    }
</style>